<template>
    <SoliForm
        ref="form"
        v-model="valid"
        :title="`Edit ${isMembership ? 'Membership' : 'Pass'} Details`"
        :textSubtitle="`Edit the price and/or tags for this ${
            isMembership ? 'membership' : 'pass'
        }.${
            isMembership
                ? ' Pricing changes will be reflected in the next billing cycle.'
                : ''
        }`"
        persistent
        :saveChanges="editing"
        @submit="submit()"
        @reset="$emit('reset')"
        ><template #body>
            <div class="flex flex-col gap-4">
                <v-currency-field
                    ref="inlinePriceText"
                    v-model="form.unit_amount"
                    :rules="[
                        (val) => !!val || 'Price is required',
                        (val) =>
                            String(val).replace(/,/g, '') >= 0 ||
                            'Price must be greater than or equal to $0.00',
                        (val) =>
                            String(val).replace(/,/g, '') <= 500 ||
                            'Price must be not be greater than $500.00',
                    ]"
                    outlined
                    dense
                    class="soli-round"
                    label="Price"
                    error-message="errors.amount"
                    prepend-inner-icon="attach_money"
                    validate-on-blur
                    :allowNegative="false"
                    hide-details="auto"
                ></v-currency-field>
                <PriceCouponDuration
                    v-if="form.unit_amount === 0"
                    v-model="form.coupon_duration"
                    :disabled="!!purchaseOption.coupon_duration"
                />
                <PriceCouponRestore
                    v-if="
                        form.coupon_duration &&
                        form.coupon_duration !== 'forever'
                    "
                    v-model="form.restore_price_id"
                    :priceId="purchaseOption.price.id"
                    :disabled="!!purchaseOption.coupon_duration"
                />
                <PriceTags ref="priceTags" v-model="form.tags" />
            </div> </template
    ></SoliForm>
</template>

<script>
import PriceCouponDuration from "../Store/PriceCouponDuration.vue";
import PriceCouponRestore from "../Store/PriceCouponRestore.vue";
import PriceTags from "../Store/PriceTags.vue";

export default {
    props: {
        purchaseOption: {
            type: Object,
            default: () => {},
        },
    },
    components: {
        PriceTags,
        PriceCouponDuration,
        PriceCouponRestore,
    },
    data() {
        return {
            form: this.$inertia.form({
                unit_amount: this.purchaseOption.price.unit_amount / 100,
                coupon_duration: this.purchaseOption.coupon_duration,
                restore_price_id: null,
                tags:
                    this.purchaseOption.tags?.filter((e) => !e.computed) ?? [],
            }),
            editing: false,
            valid: false,
            formCopy: {},
            //priceOptions: [],
        };
    },
    computed: {
        isMembership() {
            return this.purchaseOption.category == "memberships";
        },
    },
    methods: {
        /*getPrices() {
            axios
                .get(route("purchaseOption.getPrices", this.purchaseOption.id))
                .then((response) => {
                    this.priceOptions = response.data;
                });
        },*/
        submit() {
            if (!this.valid) {
                this.$refs.form.loading = false;
                return;
            }

            const options = {
                preserveState: true,
                preserveScroll: true,
                onSuccess: () => {
                    this.$refs.form.reset();
                    this.$emit("success");
                },
                onError: (errors) => {
                    console.log(
                        "Form returned errors: " + JSON.stringify(errors)
                    );
                    this.$refs.form.loading = false;
                },
            };

            this.form
                .transform((data) => ({
                    ...data,
                    unit_amount: data.unit_amount * 100,
                    tags: data.tags.map((e) => e.id),
                }))
                .put(
                    `/subscription/edit-membership-details/${this.purchaseOption.id}`,
                    options
                );
        },
    },
    mounted() {
        this.formCopy = JSON.stringify(this.form);
    },
    watch: {
        form: {
            handler: function (val) {
                if (JSON.stringify(val) == this.formCopy) {
                    this.editing = false;
                } else {
                    this.editing = true;
                }

                // Auto tag free memberships
                if (
                    val.unit_amount === 0 &&
                    this.isMembership &&
                    !val.tags.map((e) => e.name).includes("Free Membership")
                ) {
                    this.form.tags = [
                        ...val.tags,
                        this.$refs.priceTags.tags.find(
                            (e) => e.name === "Free Membership"
                        ),
                    ];
                }

                if (
                    val.unit_amount > 0 &&
                    val.tags.map((e) => e.name).includes("Free Membership")
                ) {
                    this.form.tags = val.tags.filter(
                        (e) => e.name !== "Free Membership"
                    );
                }

                if (val.unit_amount > 0) {
                    this.form.coupon_duration = null;
                }
            },
            deep: true,
        },
    },
};
</script>
